var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "wrapper",
    staticClass: "codemirror-wrapper"
  }, [_vm.isVisible ? _c('div', {
    ref: "editor"
  }) : _c('textarea', {
    ref: "textarea",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "min-height": "100px"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onTextareaInput
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };